import _awaitAsyncGenerator from "@babel/runtime/helpers/awaitAsyncGenerator";
import _wrapAsyncGenerator from "@babel/runtime/helpers/wrapAsyncGenerator";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as CodeMirror from 'codemirror';
import { Component, Inject, Vue } from 'vue-property-decorator';
import ExprInputCompletionProvider from "../../../../lib/comps/ExprInput/ExprInputCompletionProvider";
import faIcons from './utils';
import { INJECT_UICORE_DESIGNER } from "../../../../lib/utils/consts";
import { vueComponentMixin } from '@tencent/data-schema/lib/vue-ui/definitions';
import ExprInput from '../../designerComponents/ExprInput';
import { elt } from "../../../../lib/utils/browser";
import "./index.css";
import { flattenDepth } from "lodash-es";
let IconSelectorInput = class IconSelectorInput extends Vue {
  render() {
    const h = arguments[0];
    return h(ExprInputCompletionProvider, {
      "attrs": {
        "customMethodForRaw": this.getCompletionsForRaw
      }
    }, [h(ExprInput, {
      "attrs": {
        "value": this.editValue,
        "type": "interopable-string"
      },
      "on": {
        "change": txt => {
          this.editValue = txt;
        }
      }
    })]);
  }
  get iconsWithGroup() {
    return flattenDepth([...faIcons.map(group => [...group.icons])]);
  }
  getCompletionsForRaw({
    cm
  }) {
    var _this = this;
    return _wrapAsyncGenerator(function* () {
      // eslint-disable-next-line no-restricted-syntax
      for (const icon of _this.iconsWithGroup) {
        const text = icon;
        if (!text.includes(cm.getValue())) continue;
        yield {
          text,
          hint: () => {
            cm.setValue(text);
            cm.setSelection(CodeMirror.Pos(0, text.length));
          },
          render: parent => {
            parent.appendChild(elt('div', {
              style: 'padding: 2px 4px',
              class: 'grid-cm-hint-item'
            }, [elt('i', {
              class: `fa fa-${text}`
            }), elt('span', {
              style: 'margin-left: 1em'
            }, [text])]));
          }
        };
      }
    })();
  }
};
__decorate([Inject({
  from: INJECT_UICORE_DESIGNER,
  default: null
})], IconSelectorInput.prototype, "designer", void 0);
IconSelectorInput = __decorate([Component({
  name: 'IconSelectorInput',
  mixins: [vueComponentMixin]
})], IconSelectorInput);
export default IconSelectorInput;
//# sourceMappingURL=index.js.map
